"use client";

import { useDispatch, useSelector } from "react-redux";
import {
  addCartItem,
  addCartShippingMethod,
  clearCompletedCart,
  refreshCart,
  removeCartItem,
  updateCartDetails,
  updateCartItemQuantity,
} from "@/store/slices/cartSlice";
import { ORDER_TYPE, normalizeOrderType } from "@/lib/orderType";

export const useAppDispatch = useDispatch;
export const useAppSelector = useSelector;

export function useCart(orderType = ORDER_TYPE.GROCERY) {
  const dispatch = useAppDispatch();
  const type = normalizeOrderType(orderType) || ORDER_TYPE.GROCERY;

  const bucket = useAppSelector((state) => state.cart[type]);
  const region = useAppSelector((state) => state.cart.region);
  const initializing = useAppSelector((state) => state.cart.initializing);
  const globalError = useAppSelector((state) => state.cart.error);

  const cart = bucket?.cart || null;
  const count = (cart?.items || []).reduce(
    (sum, item) => sum + Number(item.quantity || 0),
    0,
  );

  return {
    orderType: type,
    cart,
    region,
    count,
    loading: initializing || Boolean(bucket?.loading),
    cartError: bucket?.error || globalError || "",

    // addToCart(variantId, quantity = 1) {
    //   return dispatch(
    //     addCartItem({ orderType: type, variantId, quantity }),
    //   )
    //     .unwrap()
    //     .then((payload) => payload.cart);
    // },

    addToCart(variantId, quantity = 1, metadata = undefined) {
      return dispatch(
        addCartItem({
          orderType: type,
          variantId,
          quantity,
          metadata,
        }),
      )
        .unwrap()
        .then((payload) => payload.cart);
    },

    // updateItemQuantity(itemId, quantity) {
    //   return dispatch(
    //     updateCartItemQuantity({ orderType: type, itemId, quantity }),
    //   )
    //     .unwrap()
    //     .then((payload) => payload.cart);
    // },

    updateItemQuantity(itemId, quantity, metadata = undefined) {
      return dispatch(
        updateCartItemQuantity({
          orderType: type,
          itemId,
          quantity,
          metadata,
        }),
      )
        .unwrap()
        .then((payload) => payload.cart);
    },

    removeItem(itemId) {
      return dispatch(removeCartItem({ orderType: type, itemId }))
        .unwrap()
        .then((payload) => payload.cart);
    },

    refreshCart(cartId) {
      return dispatch(refreshCart({ orderType: type, cartId }))
        .unwrap()
        .then((payload) => payload.cart);
    },

    updateCartDetails(data) {
      return dispatch(updateCartDetails({ orderType: type, data }))
        .unwrap()
        .then((payload) => payload.cart);
    },

    addShippingMethod(optionId) {
      return dispatch(addCartShippingMethod({ orderType: type, optionId }))
        .unwrap()
        .then((payload) => payload.cart);
    },

    resetCartAfterOrder() {
      return dispatch(clearCompletedCart({ orderType: type })).unwrap();
    },
  };
}

export function useCustomer() {
  const customer = useAppSelector((state) => state.customer?.customer || null);
  const initialized = useAppSelector((state) =>
    Boolean(state.customer?.initialized),
  );
  const loading = useAppSelector((state) => Boolean(state.customer?.loading));
  const error = useAppSelector((state) => state.customer?.error || "");

  return {
    customer,
    initialized,
    loading,
    error,
    isAuthenticated: Boolean(customer?.id),
  };
}
